module.exports = __webpack_public_path__ + "img/658.b979304c.png";